"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _plugin = _interopRequireDefault(require("@ckeditor/ckeditor5-core/src/plugin"));

var _image = _interopRequireDefault(require("@ckeditor/ckeditor5-core/theme/icons/image.svg"));

var _filedialogbuttonview = _interopRequireDefault(require("@ckeditor/ckeditor5-upload/src/ui/filedialogbuttonview"));

var _utils = require("./utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var GrooveImageUploadUI = /*#__PURE__*/function (_Plugin) {
  (0, _inherits2["default"])(GrooveImageUploadUI, _Plugin);

  var _super = _createSuper(GrooveImageUploadUI);

  function GrooveImageUploadUI() {
    (0, _classCallCheck2["default"])(this, GrooveImageUploadUI);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(GrooveImageUploadUI, [{
    key: "init",

    /**
     * @inheritDoc
     */
    value: function init() {
      var editor = this.editor;
      var t = editor.t;

      var componentCreator = function componentCreator(locale) {
        var view = new _filedialogbuttonview["default"](locale);
        var command = editor.commands.get('grooveUploadImage');
        var imageTypes = editor.config.get('image.upload.types');
        var imageTypesRegExp = (0, _utils.createImageTypeRegExp)(imageTypes);
        view.set({
          acceptedType: imageTypes.map(function (type) {
            return "image/".concat(type);
          }).join(','),
          allowMultipleFiles: true
        });
        view.buttonView.set({
          label: t('Insert image'),
          icon: _image["default"],
          tooltip: true
        });
        view.buttonView.bind('isEnabled').to(command);
        view.on('done', function (evt, files) {
          var imagesToUpload = Array.from(files).filter(function (file) {
            return imageTypesRegExp.test(file.type);
          });

          if (imagesToUpload.length) {
            editor.execute('grooveUploadImage', {
              file: imagesToUpload
            });
          }
        });
        return view;
      };

      editor.ui.componentFactory.add('grooveUploadImage', componentCreator);
    }
  }], [{
    key: "pluginName",

    /**
     * @inheritDoc
     */
    get: function get() {
      return 'GrooveImageUploadUI';
    }
  }]);
  return GrooveImageUploadUI;
}(_plugin["default"]);

exports["default"] = GrooveImageUploadUI;
//# sourceMappingURL=grooveimageuploadui.js.map